import { Briefcase, Code, Brain } from 'lucide-react'

const experiences = [
  {
    icon: <Brain size={24} />,
    title: 'M.Sc. Computational Linguistics',
    company: 'Universität Stuttgart',
    period: '2024 - Present',
    description: 'Specializing in NLP, speech synthesis, and robust AI systems. Research focus on deepfake detection benchmarking and expressive speech synthesis.',
    highlights: [
      'Built automated testing pipelines for TTS models',
      'Working with CosyVoice, Qwen3, ParlerTTS',
      'Published research on robustness testing'
    ]
  },
  {
    icon: <Code size={24} />,
    title: 'AI/ML Engineering',
    company: 'Various Projects',
    period: '2023 - 2026',
    description: 'Developed multiple AI-powered applications including browser extensions, automation agents, and full-stack applications.',
    highlights: [
      'Built dual-agent job application system',
      'Created AI health coach Android app',
      'Developed Easy Resume browser extension'
    ]
  },
  {
    icon: <Briefcase size={24} />,
    title: 'Solutions Engineering',
    company: 'Professional Experience',
    period: '2023',
    description: 'Built internal automation tools and worked on client-facing solutions, reducing manual effort by 80%.',
    highlights: [
      'Automated PowerPoint generation',
      'Excel/JSON data transformation',
      'OpenAI API integration'
    ]
  }
]

export default function Experience() {
  return (
    <section className="section-padding bg-surface/50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center font-headline">
          Experience & <span className="text-primary">Education</span>
        </h2>
        <div className="space-y-8">
          {experiences.map((exp, index) => (
            <div
              key={index}
              className="bg-surface-container-low p-8 rounded-xl border border-outline-variant/10 card-hover"
            >
              <div className="flex items-start gap-6">
                <div className="text-primary p-3 bg-primary/10 rounded-lg">
                  {exp.icon}
                </div>
                <div className="flex-1">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-white font-headline">{exp.title}</h3>
                      <p className="text-primary">{exp.company}</p>
                    </div>
                    <span className="text-sm text-on-surface-variant font-mono">{exp.period}</span>
                  </div>
                  <p className="text-on-surface-variant mb-4">{exp.description}</p>
                  <ul className="space-y-2">
                    {exp.highlights.map((highlight, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-on-surface-variant">
                        <span className="text-primary mt-1">•</span>
                        {highlight}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
